export default __webpack_public_path__ + "static/media/40.be18670a.svg";